<template>
<footer class="footer site-footer-enhanced">
  <div class="container">
    <div class="footer-highlight" data-bloco="rodape-chamada" data-tipo="conteudo">
      <div><p data-campo="iti_nome" v-html="html(rodapeChamada, 'iti_nome')"></p><h2 data-campo="iti_resumo1" v-html="html(rodapeChamada, 'iti_resumo1')"></h2></div>
      <a class="btn" data-campo="iti_textobtn1" data-link="iti_linkbtn1" :href="link(rodapeChamada, 'iti_link_btn1')" v-html="html(rodapeChamada, 'iti_texto_btn1')"></a>
    </div>
    <div class="footer-grid" data-bloco="rodape-informacoes" data-tipo="conteudo">
      <div class="footer-brand-block"><router-link class="brand" to="/"><img class="brand-logo footer-logo-original" src="/site-assets/layouts/imaginarvet-2008/assets/images/site-atual/logo-rodape-imaginar-diagnostico-veterinario.jpg" alt="Imaginar — Diagnóstico Veterinário"></router-link><p data-campo="iti_descricao1" v-html="html(rodapeInformacoes, 'iti_descricao1')"></p></div>
      <div><h4>Navegação</h4><ul class="footer-nav-complete"><li><router-link to="/">Home</router-link></li><li><router-link to="/quem-somos">Quem somos</router-link></li><li><router-link to="/exames">Exames</router-link></li><li><router-link to="/eventos">Eventos</router-link></li><li><router-link to="/blog">Blog</router-link></li><li><router-link to="/artigos">Artigos</router-link></li><li><router-link to="/galeria">Galeria Pets</router-link></li><li><router-link to="/contato">Contato</router-link></li></ul></div>
      <div><h4>Principais exames</h4><ul><li><router-link to="/exames">Tomografia</router-link></li><li><router-link to="/exames">Ultrassonografia</router-link></li><li><router-link to="/exames">Ecocardiografia</router-link></li><li><router-link to="/exames">Radiologia digital</router-link></li></ul></div>
      <div><h4 data-campo="iti_nome" v-html="html(rodapeInformacoes, 'iti_nome')"></h4><div data-campo="iti_descricao2" v-html="html(rodapeInformacoes, 'iti_descricao2')"></div><a data-link="iti_linkbtn1" :href="link(rodapeInformacoes, 'iti_link_btn1')" v-html="html(rodapeInformacoes, 'iti_texto_btn1')"></a></div>
    </div>
    <nav class="footer-legal"><router-link v-for="item in informacoesLista" :key="itemId(item)" :to="infoRoute(item)" v-html="html(item, 'iti_nome')"></router-link></nav>
    <div class="copyright"><span>© 2026 Imaginar. Todos os direitos reservados.</span><span>Desenvolvido por <a href="https://avancedigital.com.br/" target="_blank" rel="noopener">Avance Digital</a>.</span></div>
  </div>
</footer>
</template>

<script>
import {
  contentValue,
  loadScreens,
  normalizeInternalLink,
} from '@/services/contentApi';

export default {
  name: 'PageFooter',
  data() {
    return {
      rodapeChamada: {},
      rodapeInformacoes: {},
      homeRedes: {},
      informacoesLista: [],
    };
  },
  created() {
    this.loadFooterContent();
  },
  methods: {
    html(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    link(source, field, fallback = '') {
      const value = contentValue(source, field, fallback);
      if (!value || value === '0' || value === 0) return '';
      return normalizeInternalLink(value, fallback);
    },
    socialLink(field) {
      return this.link(this.homeRedes, field);
    },
    text(source, field, fallback = '') {
      return String(contentValue(source, field, fallback)).replace(/<[^>]*>/g, '').trim();
    },
    itemId(item) {
      return item?.itiId || item?.id || this.slug(this.text(item, 'iti_nome'));
    },
    slug(value) {
      return String(value || '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'informacao';
    },
    infoRoute(item) {
      return '/informacoes/' + this.itemId(item) + '/' + this.slug(this.text(item, 'iti_nome'));
    },
    async loadFooterContent() {
      const data = await loadScreens([
        { ctiId: 12, key: "rodapeChamada", multi: false },
        { ctiId: 13, key: "rodapeInformacoes", multi: false },
        { ctiId: 14, key: "homeRedes", multi: false },
        { ctiId: 33, key: "informacoesLista", multi: true },
      ]);
      Object.assign(this, data);
    },
  },
};
</script>

<style scoped>
.footer-highlight > div > p {
  color: #eadced;
  font-size: .76rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .12em;
}
.footer-highlight h2,
.footer-highlight h2 :deep(p) {
  margin: 0;
  color: #fff;
  font-size: clamp(1.45rem, 2.5vw, 2.15rem);
  font-weight: 800;
  line-height: 1.15;
  text-align: left !important;
  text-transform: none;
  letter-spacing: normal;
}
.footer-highlight h2 {
  margin-top: 4px;
}
.footer-highlight .btn::after {
  content: ' →';
}
</style>
